// Datasheet label definitions: pure helpers shared by the Definitions tabs and the label-click
// popup. Definitions are help content under keys dsdef:<label> (master) and
// dsdef:<slug>:<label> (one database's override); the API builds the keys, this side only
// normalizes labels the same way the server does so a clicked label finds its entry.

// Whitespace runs collapsed to one space and trimmed (mirrors DsDefinitions.NormalizeLabel).
export const normalizeLabel = (text) => String(text ?? '').replace(/\s+/g, ' ').trim();

// Labels share a definition when they differ only in case (the key column is case-insensitive).
export const sameLabel = (a, b) => normalizeLabel(a).toLowerCase() === normalizeLabel(b).toLowerCase();

// The list filter values and what each keeps.
export const DEFINITION_FILTERS = [
  ['all', 'All'],
  ['defined', 'Defined'],
  ['undefined', 'No definition'],
];

// Whether a label-list row has a definition showing: on the project page the override counts,
// on the master page only the master text does.
export const isDefined = (row) => !!(row?.hasMaster || row?.hasOverride);

export const filterDefinitions = (rows, filter) => {
  if (filter === 'defined') return rows.filter(isDefined);
  if (filter === 'undefined') return rows.filter(r => !isDefined(r));
  return rows;
};

// One-line summary under a label in the list.
export const definitionSummary = (row, scope) => {
  const used = row.templateCount === 0
    ? 'on no template'
    : `${row.templateCount} template${row.templateCount === 1 ? '' : 's'}`;
  let state;
  if (scope === 'project') {
    state = row.hasOverride ? 'this database\'s definition' : row.hasMaster ? 'master definition' : 'no definition yet';
  } else {
    state = row.hasMaster ? 'defined' : 'no definition yet';
    if (row.overrideCount) state += `, overridden in ${row.overrideCount} database${row.overrideCount === 1 ? '' : 's'}`;
  }
  return `${used} · ${state}`;
};

// Which definition a project read shows: { kind: 'override' | 'master' | 'none', def }.
export const shownDefinition = (read) => {
  if (read?.override) return { kind: 'override', def: read.override };
  if (read?.master) return { kind: 'master', def: read.master };
  return { kind: 'none', def: null };
};

// Rich-text editors leave markup behind when emptied ("<p></p>"); treat that as no content.
export const isBlankHtml = (html) => normalizeLabel(String(html ?? '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ')) === '';

// The server's own message when it sent one (a 400 names what was wrong), else the fallback.
export const definitionError = (e, fallback) => {
  if (e?.response?.status === 403) return 'Access denied. You do not have permission for this.';
  return e?.response?.data?.error || fallback;
};
